import React from 'react';

/**
 * Colored KPI tile — used in the 5-card strip of the executive summary.
 *
 * Props:
 *   value   {string}  – formatted number / ratio
 *   label   {string}  – card subtitle
 *   badge   {string}  – bottom label (risk level)
 *   colors  {object}  – { background, badgeBackground, badgeColor } from KPI_TONE_STYLES
 */
const ManCrossKpiCard = ({ value, label, badge, colors }) => (
    <div className="mgcr-kpi-card-wrap">
        <div className="mgcr-kpi-card" style={{ background: colors.background }}>
            <div className="mgcr-kpi-value">{value}</div>
            <div className="mgcr-kpi-label">{label}</div>
        </div>
        <div className="mgcr-kpi-foot" style={{ color: colors.badgeColor }}>
            {badge}
        </div>
    </div>
);

export default ManCrossKpiCard;
